export const convertDateRangeToTimestamp = (date) => {
    return date ? new Date(date.toDateString()).valueOf() : null;
};
